import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { SurveySearchFilter,SurveyWriteHeader, SurveyDetailHeader, SurveyReadQuestion, SurveyReadExamples, SurveyAttachmentList } from '@survey/components'
import api from '@survey/api'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as types from '@survey/store/types'
import * as dateUtil from '@appbase/util/date-helper'
import * as accountType from '@account/store/types'

//lazyLoading
const SurveyStatisticsUserSearchList = ()=> import('@survey/components/SurveyRead/SurveyStatisticsUserSearchList.vue')
 

@Component({
    components: {
        SurveySearchFilter,
        SurveyDetailHeader,
        SurveyAttachmentList,
        SurveyReadQuestion,
        SurveyReadExamples,
        SurveyWriteHeader,
        SurveyStatisticsUserSearchList
    },
    methods: {
        ...mapActions({
            addAnswer: types.SURVEY_ANSWER,
            setSurveyId: types.SURVEY_CREATED_SURVEYID
        }),
        ...mapMutations({
            initAnswer: types.SURVEY_ANSWER,
            setStatistics: types.SURVEY_STATISTICS,
            deleteAllAnswer: types.SURVEY_DELETE_ALL_ANSWER
        })
    },
    computed: {
        ...mapGetters({
            menuPermission: types.SURVEY_MENU_PERMISSIONS,
            answers: types.SURVEY_ANSWER,
            user : accountType.USER,
            current: accountType.CURRENT,
            list: types.SURVEY_LIST,
        })
    }
})
export default class SurveyReadView extends Vue {
    @Prop({ type: Boolean , default:false }) isPreview!: boolean  

    deleteAllAnswer!: () => void
    initAnswer!: (data: survey.SurveyAnswerItem) => void
    addAnswer!: (data: survey.SurveyAnswerItem) => void
    setStatistics!: (data: survey.SurveyDetailResponse) => void
    setSurveyId!: (surveyId?: number) => void
    list!: survey.SurveyListResponse

    answers!: Array<survey.SurveyAnswerItem>

    user!: account.User
    current!: account.TCurrent
    menuPermission!: survey.MenuPermissions
    
    surveyDetail: survey.SurveyDetailResponse = Object.create(null)
    surveyAttachmentList: Array<survey.SurveyAttachmentInfo> = []
    
    isReady: boolean = false
    isPopup : boolean = false
    isApproved: boolean | null = null;
    isSurveyAdmin: boolean = false;
    isSurveyOwner: boolean = false;
    isAccessable: boolean = true;

    canModifiable: boolean = false;       
    canQueryResult: boolean = false; 
    canQueryParticipants: boolean = false;

//사용자별통계 
    showSearch : boolean = false
    completionLists : Array<survey.SurveyCompletionItem> = []
    displayCompletionLists : Array<survey.SurveyCompletionItem> = []
    selectedTrNum : number = 0
     
    //이미 참여한 설문에서 수정하면 기존 store에 정보가 남아 있어
    //중복으로 설문이 진행되는 경우가 있음
    //이때 answer 빈값으로 초기화 
    destroyed() {
        this.deleteAllAnswer()
    }

    async created() {       
        this.isSurveyAdmin = this.current.permissions.isSuperAdmin || this.current.permissions.isSurveyManager;
        this.isPopup = this.$route.path.toLowerCase().includes('popup')

        this.setPage({
            title: this.isPreview ?   this.$t('설문작성').toString() :  this.$t('설문조사').toString()
        })

        try {
            //스토어를 안사용해도 될듯?
            let surveyId = parseInt(this.$route.query.surveyId as string)

            if (isNaN(surveyId)) {
                throw new Error("Invalid QueryString.(only numbers are allowed)")
            }

            api.survey.surveyDetail(surveyId).then(result => {
                if (result == null || !result.success) {
                    throw new Error("Failed to call api, beacuse response is null.")
                }

                var postPromise: Promise<any>[] = [];                
                
                if(result.surveyDetailInfo.isCompleted) {
                    postPromise.push(api.survey.getSurveyAnswerLists(surveyId).then(answerListResult => {
                        //init  answers
                        answerListResult.forEach(answer => {                                                 
                            this.initAnswer(answer)                          
                        })                                                
                    }));
                }                              
                                   
                //첨부파일이 있는경우
                if (result.surveyDetailInfo.fileCode && result.surveyDetailInfo.fileCode.length > 0) {
                    postPromise.push(api.survey.getSurveyAttachmentList(<string>result.surveyDetailInfo.fileCode)
                        .then(result => {
                            if (result.length > 0) {
                                this.surveyAttachmentList = result.map((item: any) => {
                                    return {
                                        downloadUrl: item.downloadUrl,
                                        fileName: item.name
                                    } as survey.SurveyAttachmentInfo
                                })
                            }
                        }));
                }

                Promise.all(postPromise).finally(async () => {      
                    var detailInfo = result.surveyDetailInfo;                    
                    var modifiableStatus = detailInfo.status == 1 || detailInfo.status == 2;
                    var endD = dateUtil.uGetDateFormat('yyyy-MM-dd',new Date(detailInfo.endDate));
                    var today = dateUtil.uGetDateFormat('yyyy-MM-dd',new Date())

                    this.isApproved = detailInfo.isApproval;  
                    this.isSurveyOwner = detailInfo.createdId === this.user.personCode;                                                         
                    this.canModifiable = (this.isSurveyOwner || this.isSurveyAdmin) && modifiableStatus && !detailInfo.isApproval && detailInfo.completedUserCount == 0;
                    this.canQueryParticipants = (this.isSurveyOwner || this.isSurveyAdmin) && !detailInfo.isAnonymous; 
                    this.canQueryResult = this.getCanUserQueryResult(detailInfo);  
                    console.log('canQueryResult', this.canQueryResult)                                                      
                    this.isAccessable = ( detailInfo.isTargetAll || detailInfo.isSurveyTarget ) && new Date(endD)>=new Date(today);
                    this.surveyDetail = result  

                    if(result.surveyDetailInfo.isCompleted) {
                        this.surveyDetail.questions.forEach(q => this.doAnswerFlag(q.questionInfo.surveyQuestionId))       
                    }   
                                                                           
                    if(!(this.isSurveyOwner || this.isSurveyAdmin) && !this.isAccessable) {
                        await (window as any).alertAsync(this.$t('설문참여_대상자가_아닙니다').toString())
                        this.goBack()
                    }

                    this.isReady = true                                              
                });
            })
        } catch (err) {
            await (window as any).alertAsync(this.$t('잘못된_접근입니다').toString())
            this.goBack()
            throw err
        }
    }

    getCanUserQueryResult(detail: survey.SurveyDetailItem): boolean { 
        if(detail.status >= 2) {   
            if(this.isSurveyOwner || this.isSurveyAdmin) {
                return true;
            } else {
                const Start: Date = dateUtil.IEDate(dateUtil.uGetDateFormat('yyyy-MM-DD', dateUtil.IEDate(detail.resultStartDate)));
                const End: Date =  dateUtil.IEDate(detail.resultEndDate);   
                let inDate: boolean = dateUtil.uGetIsInDate(new Date(), Start, End);

                if(detail.isPublic && inDate) {
                    return true;
                } else {
                    return false;
                }
            }                
        } else {
            return false;
        }
    }

    goBack() {       
        if (this.isPopup) {
            window.close()
        } 
        else if(this.isPreview){
            this.$router.go(-1)
        }
        else {
           this.goList()
        }
    }

    async goListPreview(){
        if(await (window as any).confirmAsync(this.$t('저장하지_않고_목록으로_이동하면_작성_중_상태가_유지_됩니다_').toString())){
            this.goList()
        }
    }

    async deleteHard() {
        var { surveyId } = this.$route.query;

        if(surveyId) {
            var deleteId = parseInt(surveyId.toString()); 
            
            if(await (window as any).confirmAsync(this.$t('저장하지않고_취소').toString())) {
                api.survey.deleteHardSurvey([ deleteId ]).then(res => {
                    this.setSurveyId()
                    this.goList()
                });
            }
        }                  
    }

    async previewSave(){
        if (await (window as any).confirmAsync(this.$t('저장_하시겠습니까').toString())) {
            //유효성체크
            const surveyId  = parseInt(<string>this.$route.query.surveyId)
            api.survey.setSurveyComposingStatus({
                surveyId: surveyId,
                isComposing: false
            }).then(result => {
                if (result) {
                    this.goList()
                } else {
                    (window as any).alertAsync(this.$t('저장_실패').toString())
                }
            })
        }
    }

    goList(){
        this.$router.push({
            name: "SurveyList",
            query: {
                type: this.$route.query.type,
                MENUID: this.$route.query.MENUID
            }
        })
    }

    async edit() {
        //체크액션이 아니라 관리자 아니면 안보이면 됨
        //수정 상태로 진입하면 리스트에 노출 안됨
        //개시 승인이 된 상태면 수정 불가
        let surveyId = parseInt(this.$route.query.surveyId as string);
        let isApprovalSurvey: boolean = false;
        this.list.surveyLists.forEach((list)=>{
            if(list.surveyId == surveyId){
                if(list.isApproval){
                    isApprovalSurvey = true; 
                }
            }
        })
        if(isApprovalSurvey){
            (window as any).alertAsync(this.$t('게시승인된_설문_수정불가').toString());
            return;
        }
    
        if (await (window as any).confirmAsync(this.$t('수정하시겠습니까').toString())) {
            this.setSurveyId(surveyId);
            
            api.survey.setSurveyComposingStatus({
                surveyId: surveyId,
                isComposing: true
            }).then(result => {
                if (result) {
                    this.$router.push({
                        name: this.isPopup ? "SurveyPopupWriteStep01" : "SurveyWriteStep01",
                        query: {
                            surveyId: this.$route.query.surveyId,
                            MENUID: this.$route.query.MENUID
                        }
                    })
                } else {
                    (window as any).alertAsync(this.$t('수정_실패').toString())
                }
            })

        }
    }

    updateAnswer(data: survey.SurveyAnswerItem) {              
        data.surveyId = this.surveyDetail?.surveyDetailInfo.surveyId as number        
        this.addAnswer(data)
        this.doAnswerFlag(data.surveyQuestionId)
    }
 
    doAnswerFlag(questionId?: number) {
        if(this.surveyDetail && questionId) {
            let question = this.surveyDetail.questions.find(q => q.questionInfo.surveyQuestionId === questionId);

            if(question) {
                if (question.questionInfo.questionType === 2) {
                    var found =  this.answers.find(a => a.surveyQuestionId === questionId)
                    question.questionInfo.doAnswer = (found && found.surveyAnswer.trim().length > 0);                   
                } else if (question.questionInfo.questionType === 3) {
                    var validateArr = question.examples.map(e => {
                        let found = this.answers.find(a => a.surveyQuestionId === questionId && a.surveyExampleId === e.surveyExampleId);
                        return found && found.surveyAnswer.trim().length > 0;
                    });

                    question.questionInfo.doAnswer = validateArr.every(a => a);                   
                } else {
                    question.questionInfo.doAnswer = this.answers.findIndex(a => a.surveyQuestionId === questionId) >= 0;                  
                }                                  

                console.log('doAnswer', question.questionInfo.doAnswer);
            }
        }              
    }

    checkAnswerAll() {        
        //응답을 모두했는지 확인
        //doAnswerFlag 카운트 비교
        let entireQuestionCount = this.surveyDetail.questions.length

        let doAnswerCount = this.surveyDetail.questions.filter(item => {
            return item.questionInfo.doAnswer == true
        }).length


        if (entireQuestionCount == doAnswerCount) {
            return true
        } else {
            return false
        }
    }

    save() {        
        if (this.checkAnswerAll()) {
            let answerData : any = []
            if(this.answers.length == 0){
                answerData = [{
                    surveyId : parseInt(this.$route.query.surveyId as string)
                }]
            }else{
                answerData = this.answers
            }

            api.survey.insertSurveyAnswer({
                answers: answerData 
            }).then(async result => {
                if (result.success) {
                    await (window as any).alertAsync(this.$t('설문_응답_완료').toString())
                    this.goBack()
                } else {
                    (window as any).alertAsync(this.$t('설문응답_저장_실패').toString())
                }
            })
        } else {
            (window as any).alertAsync(this.$t('모든_설문_응답').toString())
        }
    }


    getAnswerByid(questionId: number) {
        let answer = this.answers.filter(item => {
            return item.surveyQuestionId == questionId
        })

        return answer
    }

    goStatistics() {               
        this.setStatistics(this.surveyDetail) /// 설문정보(질문,보기)

        this.$router.push({
            name: this.isPopup ? "SurveyPopupStatistics" : "SurveyStatistics",
            query: {
                surveyId: this.surveyDetail.surveyDetailInfo.surveyId?.toString(),
                MENUID: this.$route.query.MENUID
            }
        })
    }

    async deleteSurvey() {
        var deleteId = this.surveyDetail.surveyDetailInfo.surveyId;

        if(deleteId && await (window as any).confirmAsync(this.$t('삭제하시겠습니까').toString())) {            
            api.survey.deleteSurvey([ deleteId ]).then(async res => {
                await (window as any).alertAsync(this.$t('설문삭제_완료').toString())
                this.goBack()
            });
        }       
    }

    async nowPosting() {
        if (await (window as any).confirmAsync(this.$t('바로게시하시겠습니까').toString())) {
            api.survey.setSurveyNowPosting(<number>this.surveyDetail.surveyDetailInfo.surveyId)
                .then(async result => {
                    if (result) {
                        await (window as any).alertAsync(this.$t('게시완료').toString())
                        this.goBack()
                    } else {
                        (window as any).alertAsync(this.$t('게시_실패').toString())
                    }
                })
        }
    }

    async nowClosing(){
        if (await (window as any).confirmAsync(this.$t('설문_즉시_종료').toString())) {

            api.survey.setSurveyNowClosing(<number>this.surveyDetail.surveyDetailInfo.surveyId)
                .then(async result => {
                    if (result) {

                        await (window as any).alertAsync(this.$t('설문종료').toString())
                        this.goBack()
                    } else {

                        (window as any).alertAsync(this.$t('설문_종료가_실패').toString())
                    }
                })
        }
    }

    statisticsByUser(){
        this.showSearch = !this.showSearch        
        const surveyId = <number>this.surveyDetail.surveyDetailInfo.surveyId
        
        //데이터 없을 때 api 콜
        if(this.showSearch && this.completionLists.length == 0 ){
            api.survey.getSurveyCompletionLists(surveyId).then(result =>{
                this.completionLists = result.lists
                this.displayCompletionLists = result.lists.map(item =>{
                    return {
                        ...item,
                        displayCreatedDate : this.convertDate(item.createdDate.toString())
                    }
                })

                const personCode = this.user.personCode
                
                const target = result.lists.filter(item =>{
                    return item.personCode == personCode
                }) 
   
                
                if(target.length > 0){
                    const indexNum = result.lists.indexOf(target[0])
                    this.selectedTrNum = indexNum+1
                }
            })
        }else if(!this.showSearch){
            api.survey.getSurveyAnswerLists(surveyId).then(answerListResult => {
                //init  answers
                this.completionLists = []
                this.displayCompletionLists = []

                answerListResult.forEach(answer => {                   
                    this.initAnswer(answer)
                })                         
            })
        }      
    }
     
    convertDate(date: string) {
        return dateUtil.uGetDateFormat_UTC("yyyy.MM.dd H:i:s", new Date(date))
    }    

    onSelectCompletion(index : number){
        this.selectedTrNum = index
        const surveyId = <number>this.surveyDetail.surveyDetailInfo.surveyId

        api.survey.getSurveyAnswerLists(surveyId).then(answerListResult => {
            //init  answers
 
            answerListResult.forEach(answer => {             
                this.initAnswer(answer)
            })                  
        })
    }

    onChangedSearch(keyword : string){
        
        //검색 할 때 선택된 로우 해제
        this.selectedTrNum = 0

        let parseKeyword = keyword.toLowerCase() // 대소문자 구분 X

        if(keyword == ""){
            this.displayCompletionLists = this.completionLists.map(item =>{
                return {
                    ...item,
                    displayCreatedDate: this.convertDate(item.createdDate.toString())
                }
            })
        }else{
            this.displayCompletionLists = this.completionLists.filter(item =>{
                return item.displayName.toLowerCase().includes(parseKeyword) || 
                       item.deptName.toLowerCase().includes(parseKeyword) ||
                       item.titleName.toLowerCase().includes(parseKeyword)
            }).map(item =>{
                return {
                    ...item,
                    displayCreatedDate: this.convertDate(item.createdDate.toString())
                }
            })
        }
    }
    
}
